module.exports = "static/assets/30d09ba32a17082ef820b57d52d60b7b.hex";